import { useEffect } from 'react';
import { getCookieData } from 'utils/cookieHandler';

const commonHeaderCss = `.aside__menu__link {
    font-size: 12px !important;
    justify-content: inherit;
  }
  #hypertest__link .new__badge {margin-left:0}
  .header__collapsed #hypertest__link .new__badge {margin-left:-12px}`;
function useOldCommonHeader() {
  const commonHeaderVersion = getCookieData('common_header_version');

  const url = process.env.REACT_APP_PROD_URL;
  const commonHeaderFunction = () => {
    return `(function () {
        if (window?.location?.pathname.split('/')[1] !== 'share') {
          let script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = 'https://common-header.lambdatest.com/js/lambda_header.js';
          const redirect_uri = '${url}';
          if (
            redirect_uri.indexOf('stage') !== -1 ||
            redirect_uri.indexOf('dev') !== -1 ||
            redirect_uri.indexOf('qa-beta') !== -1 ||
            redirect_uri.indexOf('qa-beta1') !== -1
          ) {
            script.src =
              'https://stage-common-header.lambdatestinternal.com/js/lambda_header.js';
          }
          if (redirect_uri.indexOf('preprod') !== -1) {
            script.src =
              'https://common-header.lambdatest.com/js/lambda_header.js';
          }
          script.id = 'lambda__header__script';
          if (
            window.location.pathname.includes('public') ||
            window.location.pathname.includes('jenkins')
          ) {
            console.log('in public url');
          } else {
            document.head.appendChild(script);
          }
        }
        })();`;
  };

  useEffect(() => {
    const oldScript = document.getElementById('lambda__header__script');
    const oldCHStylesheet = document.getElementById(
      'lt_old_common_header_stylesheet'
    );

    if (commonHeaderVersion === 'new') {
      // Do nothing.
      if (oldScript) {
        oldScript.remove();
      }
      if (oldCHStylesheet) {
        oldCHStylesheet.remove();
      }
      const commonHeaderStylesheet = document.getElementById(
        'lambda__header__stylesheet'
      );
      if (commonHeaderStylesheet) {
        commonHeaderStylesheet.remove();
      }
    } else {
      if (!oldScript) {
        const commonHeaderScript = document.createElement('script');
        commonHeaderScript.type = 'text/javascript';
        const inlineConfigScript = document.createTextNode(
          `${commonHeaderFunction()}`
        );
        commonHeaderScript.appendChild(inlineConfigScript);
        document.head.appendChild(commonHeaderScript);
      }
      if (!oldCHStylesheet) {
        const commonHeaderStyles = document.createElement('style');
        commonHeaderStyles.rel = 'stylesheet';
        commonHeaderStyles.type = 'text/css';
        commonHeaderStyles.id = 'lt_old_common_header_stylesheet';
        if (commonHeaderStyles.styleSheet) {
          commonHeaderStyles.styleSheet.cssText = commonHeaderCss;
        } else {
          commonHeaderStyles.appendChild(
            document.createTextNode(commonHeaderCss)
          );
        }
        document.head.appendChild(commonHeaderStyles);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useOldCommonHeader;
